const VerticalBeams = () => {
  const beams = Array.from({ length: 10 });

  return (
    <div className="beams-wrapper">

      {/* Soft Background Glow */}
      <div className="center-glow"></div>

      {/* Vertical Beams */}
      {beams.map((_, i) => (
        <div
          key={i}
          className="beam"
          style={{
            animationDelay: `${i * 0.5}s`,
            height: `${250 + (i % 3) * 40}px`,
          }}
        ></div>
      ))}

      {/* Floating Particles */}
      <div className="particles">
        {Array.from({ length: 18 }).map((_, i) => (
          <span
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 4}s`,
              animationDuration: `${3 + Math.random() * 4}s`,
            }}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default VerticalBeams;
